/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Compare_DescriptionInputs */

const en_meta_compare_description = /** @type {(inputs: Meta_Compare_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A fair comparison of text-to-speech apps for students and researchers: prices, free plans, citation skipping, Zotero, voices and ratings.`)
};

const es_meta_compare_description = /** @type {(inputs: Meta_Compare_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una comparación justa de apps de texto a voz para estudiantes e investigadores: precios, planes gratuitos, omisión de citas, Zotero, voces y valoraciones.`)
};

/**
* | output |
* | --- |
* | "A fair comparison of text-to-speech apps for students and researchers: prices, free plans, citation skipping, Zotero, voices and ratings." |
*
* @param {Meta_Compare_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const meta_compare_description = /** @type {((inputs?: Meta_Compare_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Compare_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_meta_compare_description(inputs)
	return en_meta_compare_description(inputs)
});